import React from 'react';
import { useDispatch } from "react-redux";
import { FreeBusyStatus, WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';
import { updateMovement } from '@features/whereabouts/store/editMovements.duck';
import { DATE_FORMAT } from '@shared/utils/DateUtils';
import { MovementImage } from "../../../atoms/MovementImage";
import { getTranslationKey, iconPackPath, isStaticWhereabouts } from '@shared/utils/WhereaboutsHelper';
import { BodyRegular, BodyVerySmall } from "../../../atoms/fonts/Body";
import Colours from "../../../atoms/Colours";
import { Moment } from "moment";
import { useTranslation } from "react-i18next";

export function StandardActivityItem(props: Props) {
  const {activeDay, iconPack, activity, activeUserId} = props;
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const isStaticWhereaboutsOption = isStaticWhereabouts(props.activity);

  const updateSelectedDay = (e: any, option: WhereaboutsOption) => {
    e.stopPropagation();
    dispatch(updateMovement({selectedOption: option, locationId: 0, activeDay: activeDay?.format(DATE_FORMAT), activeUserId}));
  }

  return (<div className="activity" onClick={(e: any) => updateSelectedDay(e, activity)}>
    <MovementImage src={iconPackPath(iconPack, activity.image, FreeBusyStatus.FREE)} alt={activity.alt}/>
    {isStaticWhereaboutsOption ? <BodyRegular weight={600}>{t(getTranslationKey(activity))}</BodyRegular> : <BodyRegular weight={600}>{activity.label}</BodyRegular>}

    {props?.activity?.isPrivate && <BodyVerySmall colour={Colours.mildGrey} title={'This is only visible to you, line managers, and company admins.'}>Private</BodyVerySmall>}
  </div>)
}

interface Props {
  activeDay?: Moment;
  iconPack: any;
  activity: any;
  activeUserId?: string;
}
